package guide.kuki.app.engine

/**
 * A radial slice between two adjacent radial lines (r0 and r1).
 * Each slice is subdivided into blocks along the radial direction
 * according to the section [divs].
 */
class Slice(
    val idx: Int = -1,
    val r0: List<Coords> = emptyList(),
    val r1: List<Coords> = emptyList(),
    val divs: List<Int> = emptyList(),
) {
    val isValid: Boolean = r0.isNotEmpty() && r1.isNotEmpty()
    val lastIdx: Int = if (r0.isNotEmpty()) r0.size - 1 else 0

    fun isSector(): Boolean = isValid && r0[lastIdx] == r1[lastIdx]

    fun containsLatLon(latLon: LatLng): Boolean {
        if (!isValid) return false
        val pt = doubleArrayOf(latLon.lng, latLon.lat)
        return if (isSector()) {
            toLeftOfLine(pt, r0[0].lonlat, r0[lastIdx].lonlat)
                    && toLeftOfLine(pt, r1[lastIdx].lonlat, r1[0].lonlat)
                    && toLeftOfLine(pt, r1[0].lonlat, r0[0].lonlat)
        } else {
            toLeftOfLine(pt, r0[0].lonlat, r0[lastIdx].lonlat)
                    && toLeftOfLine(pt, r1[lastIdx].lonlat, r1[0].lonlat)
                    && toLeftOfLine(pt, r1[0].lonlat, r0[0].lonlat)
                    && toLeftOfLine(pt, r0[lastIdx].lonlat, r1[lastIdx].lonlat)
        }
    }

    fun getSection(sectionIdx: Int): Block {
        val block = Block(
            idx = sectionIdx,
            pts = arrayOf(r0[sectionIdx], r0[sectionIdx + 1], r1[sectionIdx], r1[sectionIdx + 1])
        )
        block.slice = this
        return block
    }

    fun getBlock(blockIdx: Int): Block {
        var totalDivs = 0
        var section = 0
        var sectionIdx = blockIdx
        for (i in divs.indices) {
            if (blockIdx < totalDivs + divs[i]) {
                section = i
                sectionIdx = blockIdx - totalDivs
                break
            }
            totalDivs += divs[i]
        }

        val sectionBlock = Block(
            idx = blockIdx,
            pts = arrayOf(r0[section], r0[section + 1], r1[section], r1[section + 1])
        )
        val blk = sectionBlock.calcSubBlock(sectionIdx, 0, divs[section], 1)
        blk.idx = blockIdx
        blk.slice = this
        return blk
    }

    fun findBlock(latlng: LatLng, blocksPerRadial: Int): Block {
        val pt = doubleArrayOf(latlng.lng, latlng.lat)
        for (i in 0 until blocksPerRadial - 1) {
            val blk = getBlock(i)
            if (toLeftOfLine(pt, blk.pts[1].lonlat, blk.pts[3].lonlat)) {
                return blk
            }
        }
        return getBlock(blocksPerRadial - 1)
    }
}
